<svg width="72" height="74" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="btn_float" viewBox="0 0 74 74" shape-rendering="geometricPrecision" text-rendering="geometricPrecision">
  <defs>
    <filter id="btn_float-s-g1-filter" x="0" y="0" width="74" height="74" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dy="-1"/>
      <feGaussianBlur stdDeviation="5"/>
      <feComposite in2="hardAlpha" operator="out"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_16116_15484"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_16116_15484" result="shape"/>
    </filter>
  </defs>
  <g id="btn_float-s-g1" filter="url(#btn_float-s-g1-filter)">
    <circle id="btn_float-s-circle1" r="27" transform="translate(37 41)" fill="var(--color-circle-fill)" />
    <circle cx="37" cy="41" r="26.5" fill="none" stroke="var(--color-brand-secondary)"/>
  </g>
  <g id="btn_float-s-circle2_to" transform="translate(28,32)">
    <circle id="btn_float-s-circle2" r="5" transform="translate(0,0)" fill="var(--color-circle-secondary)" />
  </g>
  <g id="btn_float-s-circle3_to" transform="translate(28,49)">
    <circle id="btn_float-s-circle3" r="5" transform="translate(0,0)" fill="var(--color-circle-primary)" />
  </g>
  <g id="btn_float-s-circle4_to" transform="translate(45,32)">
    <circle id="btn_float-s-circle4" r="5" transform="translate(0,0)" fill="var(--color-circle-primary)" />
  </g>
  <g id="btn_float-s-circle5_to" transform="translate(45,49)">
    <circle id="btn_float-s-circle5" r="5" transform="translate(0,0)" fill="var(--color-circle-secondary)" />
  </g>
</svg>
